module.exports = __webpack_public_path__ + "img/btn-announce-active.ca275799.svg";